import Meta from '@/components/common/Meta'
import { META_CONTENTS } from '@/v1/constants/seo'
import ResidentialStorageFeePage from '@/v2/components/pages/public-pages/residential-storage-fee-page'
import { faqSectionContent, metaImages, ogImages } from '@/v2/constants/pages/public-pages/residential-storage-fee-page'

interface ResidentialStorageFeePageProps {}

const Page: React.FC<ResidentialStorageFeePageProps> = () => {
  return (
    <>
      <Meta
        title={META_CONTENTS.residential_storage_fee.title ?? ''}
        keywords={META_CONTENTS.residential_storage_fee?.keywords ?? ''}
        description={META_CONTENTS.residential_storage_fee?.description ?? ''}
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
        additionalData={{
          faq: faqSectionContent.questions
        }}
      />

      <ResidentialStorageFeePage />
    </>
  )
}

export default Page
